import React from "react";
import { NO_GPS, STALE_GPS } from "./trackingRules";

const TILE_LOOK = {
  [NO_GPS]: { cls: " trk-tile-nogps", icon: "fas fa-satellite-dish" },
  [STALE_GPS]: { cls: " trk-tile-stale", icon: "fas fa-history" },
};

/**
 * Counters of the vehicles on job: the total (info only), then one tile per trip status, No GPS and Stale GPS (last GPS older than 15 min) — a click shows only
 * those vehicles (click again to show all). Also the refresh time and the Refresh button.
 */
export default function TrackingSummary({ total, tiles, tile, onTile, updatedAt, refreshing, onRefresh }) {
  return (
    <section className="hcf-summary dsp-summary trk-summary" aria-label="Summary">
      <div className="hcf-summary__info">
        <div className="hcf-counter hcf-counter--info" title="Vehicles on job">
          <i className="fas fa-truck-moving" aria-hidden="true" />
          <strong>{total}</strong>
          <span>on job</span>
        </div>
      </div>
      <div className="hcf-summary__actions">
        {tiles.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`hcf-counter hcf-counter--action dsp-tile${TILE_LOOK[t.id]?.cls ?? ""}${tile === t.id ? " is-selected" : ""}`}
            aria-pressed={tile === t.id}
            title={tile === t.id ? "Show all vehicles" : `Show ${t.label.toLowerCase()} vehicles`}
            onClick={() => onTile(tile === t.id ? "" : t.id)}
          >
            <i className={TILE_LOOK[t.id]?.icon ?? "fas fa-car"} aria-hidden="true" />
            <strong>{t.count}</strong>
            <span>{t.label.toLowerCase()}</span>
            <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
          </button>
        ))}
      </div>
      <div className="trk-refresh">
        {updatedAt && <span className="trk-updated">Updated {updatedAt}</span>}
        <button type="button" className="btn btn-outline-primary btn-sm" disabled={refreshing} title="Refresh now (auto every 30 s)" onClick={onRefresh}>
          <i className={`fas fa-sync-alt${refreshing ? " fa-spin" : ""}`} aria-hidden="true" /> Refresh
        </button>
      </div>
    </section>
  );
}
